<script setup lang="ts">
import type { LinkBreadcrumbItem } from '@shared/ui/menus'

import { AppRoute } from '@shared/config'
import { NavigationBreadcrumbs } from '@shared/ui/menus'

defineOptions({
  name: 'HeaderTutorAttendanceRates',
})

const config = computed<LinkBreadcrumbItem[]>(() => [
  { id: 'tutor-attendance-rates', text: 'Tutor attendance rates', to: AppRoute.TutorAttendanceRates, disabled: true },
])
</script>

<template>
  <NavigationBreadcrumbs :config="config" />
</template>
